import script from "./TaskFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./TaskFormModal.vue?vue&type=style&index=0&id=7e11f97d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e11f97d"]])

export default __exports__